import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, first } from 'rxjs';
import { TagsApiService } from '../apis/tags-api.service';
import { DottedDropdownAction } from '../dotted-dropdown/dotted-dropdown.component';
import { Common } from '../lib/common-methods';
import { LocalStorageService } from '../lib/local-storage.service';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { ReservationTag, ReservationTagCategory } from '../model/reservation-tag';
import { BatchCategoryUpdate, CategoryTagDTO, TagDTO, TagsRootDTO } from '../model/tags.dto';
import { ReservationTagModalComponent } from '../reservation-tag-modal/reservation-tag-modal.component';
import * as AppActions from './../store/actions/app.actions';

@Component({
  selector: 'app-reservation-tags',
  templateUrl: './reservation-tags.component.html',
  styleUrls: ['./reservation-tags.component.scss']
})
export class ReservationTagsComponent implements OnInit {

  constructor(private store: Store<{}>) { }

  ngOnInit(): void {
    this.store.dispatch({ type: AppActions.loadTags.type });
  }

}
